import {
    message,
    PageHeader,
    Spin,
    Row,
    Col,
    Divider,
    Select,
  } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import {
    Form,
    FormItem,
    SelectItem,
    InputNumberItem,
    cuentaMask,
    InputItem,
    ButtonItem,
    SwitchItem,
    ErrorItem,
  } from "../../../../Components/Items";
  import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
  
  const { Option } = Select;
  
  class EditarRetencion extends Component {
    formRef = React.createRef();
    state = {
      loading: false,
      modalAgregarCuentaContable: false,
      todasCuentasContablesFinales: null,
      objetoCuentasContablesFinales: null,
      objetoCalcularSobre: (
        <>
        <Option value={1} key={1}>
          Subtotal
        </Option>
        <Option value={2} key={2}>
          Acumulado
        </Option>
        </>
      ),
      id: this.props.location.state.id,
      utilizado: false
    };
    componentDidMount() {
      this.consultarTodo();
    }
    async consultarTodo() {
      this.setState({ loading: true });
      await axios
        .post(
          "cuentascontables/selectCuentasContablesFinales",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasCuentasContablesFinales: res.data });
            this.setState({
              objetoCuentasContablesFinales: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {cuentaMask(
                      value.nivel1 +
                        value.nivel2 +
                        value.nivel3 +
                        value.nivel4 +
                        value.nivel5
                    ) +
                      " - " +
                      value.descripcion}
                  </Option>
                );
              }),
            });
          }
        });
        await axios
        .post(
          "regimenfiscal/selectRegimenesFiscales",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasRegimenFiscal: res.data });
            this.setState({
              objetoRegimenFiscal: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.c_RegimenFiscal + " - " + value.descripcion}
                  </Option>
                );
              }),
            });
          }
        });
        await axios
        .post(
          "retenciones/datosRetencion",
          { empresaId: this.props.empresaId, retencionId: this.state.id },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.error("Error no se encontro informacion de la retencion");
          } else {
            if(res.data.utilizado){
              message.info('No se puede modificar toda la informacion ya que la retencion ya fue utilizada')
            }
            this.formRef.current.setFieldsValue({
              ...res.data,
            });
            this.setState({
              utilizado: res.data.utilizado,
            })
          }
        });
      this.setState({ loading: false });
    }
    atras() {
      this.props.history.goBack();
    }
    onFinishFailed(e) {
      ErrorItem(e);
    }
    onFinish(values) {
      this.setState({ loading: true });
      axios
        .post(
          "retenciones/editarRetencion",
          { ...values, empresaId: this.props.empresaId, retencionId: this.state.id },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Se edito una retencion");
            this.formRef.current.resetFields();
            this.atras(res.data.id);
          } else {
            message.error("Sucedio un error y no se edito");
          }
        });
    }
    abrirAgregarCuentaContable() {
      this.setState({ modalAgregarCuentaContable: true });
    }
    cerrarAgregarCuentaContable(codigo) {
      this.setState({ modalAgregarCuentaContable: false });
      this.consultarTodo()
    }
    onChangeLocal(value){
      if(value){
        this.formRef.current.setFieldsValue({
          impuesto: undefined,
          combustible: false
        })
      }
    }
    render() {
      return (
        <>
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Editar Retencion"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
          />
          <div className="card-background">
            <Spin spinning={this.state.loading}>
              <Form
                ref={this.formRef}
                name="editarRetencion"
                layout
                bottom={
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Editar
                  </ButtonItem>
                }
                onFinish={this.onFinish.bind(this)}
                onFinishFailed={this.onFinishFailed}
              >
                <Row>
                  <Col span={12}>
                    <FormItem
                      name="nombre"
                      label="Nombre"
                      required
                      margin
                      pattern
                    >
                      <InputItem placeholder="Nombre" />
                    </FormItem>
                      <FormItem
                      label="Local"
                      tooltip="Activar en impuestos locales. Ej: ISR"
                      name="local"
                      margin
                      initialValue={false}
                      valuePropName="checked"
                    >
                      <SwitchItem disabled={this.state.utilizado} onChange={this.onChangeLocal.bind(this)} />
                    </FormItem>
                    <FormItem shouldUpdate noStyle>
                      {({getFieldValue}) => {
                        const local = getFieldValue('local')
                        if(!local){
                          return (
                            <FormItem
                              name="impuesto"
                              label="Impuesto"
                              required
                              margin
                              pattern
                            >
                              <SelectItem
                                width="100%"
                                placeholder="Impuesto"
                                disabled={this.state.utilizado}
                              >
                                <Option key={1} value={1}>001 - ISR</Option>
                                <Option key={2} value={2}>002 - IVA</Option>
                              </SelectItem>
                            </FormItem>
                          )
                        }
                      }}
                    </FormItem>
                  </Col>
                  <Col span={12}>
                  <FormItem shouldUpdate noStyle>
                      {({getFieldValue}) => {

                        const enProvClien = getFieldValue('enProvClien')

                        return (
                          <FormItem
                            label={enProvClien ? "En Proveedores/Clientes" :"En insumos"}
                            tooltip="Activar para elegir en proveeedores y clientes"
                            name="enProvClien"
                            margin
                            initialValue={false}
                            valuePropName="checked"
                          >
                            <SwitchItem disabled={this.state.utilizado} />
                          </FormItem>
                        )
                      }}
                    </FormItem>
                    <FormItem shouldUpdate noStyle>
                        {({getFieldValue}) => {
                            const enProvClien = getFieldValue('enProvClien')
                          if(enProvClien){
                            return (
                              <>
                              <FormItem
                              name="regimenFiscalId"
                              label="R. Fiscal"
                              margin
                              tooltip={{ title: "Opcional para incluir al crear un proveedor" }}
                            >
                              <SelectItem placeholder="Regimen Fiscal">
                                {this.state.objetoRegimenFiscal}
                              </SelectItem>
                            </FormItem>
                            <FormItem shouldUpdate noStyle>
                              {({getFieldValue}) => {

                                const enClientes = getFieldValue('enClientes')

                                return (
                                  <FormItem
                                    label={enClientes ? "En Clientes" :"En Proveedores"}
                                    name="enClientes"
                                    margin
                                    initialValue={false}
                                    valuePropName="checked"
                                  >
                                    <SwitchItem disabled={this.state.utilizado} />
                                  </FormItem>
                                )
                              }}
                            </FormItem>
                            </>
                            )
                          }else{
                            return (
                              <>
                              <FormItem
                              required
                              margin
                              label='Aplica Compra'
                              name="aplicaCompra"
                            >
                              <SelectItem disabled={this.state.utilizado} width="100%">
                                <Option value={0}>Ninguno</Option>
                                <Option value={1}>Personas fisicas</Option>
                                <Option value={2}>Personas morales</Option>
                                <Option value={3}>Todas</Option>
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              required
                              margin
                              label='Aplica Venta'
                              name="aplicaVenta"
                            >
                              <SelectItem disabled={this.state.utilizado} width="100%">
                              <Option value={0}>Ninguno</Option>
                                <Option value={1}>Personas fisicas</Option>
                                <Option value={2}>Personas morales</Option>
                                <Option value={3}>Todas</Option>
                              </SelectItem>
                            </FormItem>
                            </>
                            )
                          }
                        }}
                    </FormItem>
                  </Col>
                </Row>
                <Divider
                  style={{ marginBottom: 0, marginTop: 5 }}
                  children="Cuentas de la Retencion"
                />
                        <table className="table">
                            <thead>
                              <tr>
                              <th className="th-border" style={{width: '25%'}}>Retención Compra</th>
                                <th className="th-border" style={{width: '25%'}}>Retención Venta</th>
                                <th className="th-border" style={{width: '25%'}}>Calcular Sobre</th>
                                <th className="th-border" style={{width: '25%'}}>Monto</th>
                              </tr>
                            </thead>
                              <tbody>
                                <tr>
                                <td className="td-border">
                                    <FormItem                                      
                                      name={"cuentaContableCompraId"}
                                      required
                                      noStyle
                                    >
                                      <SelectItem
                                        sinBorde
                                      disabled={this.state.utilizado}
                                        width="100%"
                                        placeholder="Retención Compra"
                                      >
                                        {
                                          this.state
                                            .objetoCuentasContablesFinales
                                        }
                                      </SelectItem>
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    <FormItem                                      
                                      name={"cuentaContableVentaId"}
                                      required
                                      noStyle
                                    >
                                      <SelectItem
                                        sinBorde
                                      disabled={this.state.utilizado}
                                        width="100%"
                                        placeholder="Retención Venta"
                                      >
                                        {
                                          this.state
                                            .objetoCuentasContablesFinales
                                        }
                                      </SelectItem>
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    <FormItem                                      
                                      name={"tasaCuota"}
                                      required
                                      noStyle
                                      initialValue={1}
                                    >
                                      <SelectItem
                                        sinBorde
                                        width="100%"
                                        placeholder="Calcular Sobre"
                                        disabled={this.state.utilizado}
                                        onChange={async () => {
                                          let monto = await this.formRef.current.getFieldValue('monto')
                                          monto = undefined
                                          this.formRef.current.setFieldsValue(monto)
                                        }}
                                      >
                                        {this.state.objetoCalcularSobre}
                                      </SelectItem>
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    <FormItem noStyle shouldUpdate>
                                      {({getFieldValue}) => {
                                        const tasaCuota = getFieldValue('tasaCuota')
                                        let properties = {
                                          placeholder:"Monto",
                                          porcentaje: tasaCuota === 3 || !tasaCuota? false : true,
                                          dinero: tasaCuota === 3 || !tasaCuota ? true : false,
                                        }
                                        return (
                                          <FormItem                                            
                                            name={"monto"}
                                            required
                                            number
                                            noStyle
                                            initialValue={undefined}
                                          >
                                            <InputNumberItem disabled={this.state.utilizado} sinBorde {...properties}/>
                                          </FormItem>
                                        )
                                      }}
                                    </FormItem>
                                  </td>
                                </tr>
                              </tbody>
                        </table>
              </Form>
            </Spin>
          </div>
          <AgregarCuentaContable
            visible={this.state.modalAgregarCuentaContable}
            cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
          />
        </>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
    };
  };
  
  export default connect(mapStateToProps)(EditarRetencion);
  